/**
 * 2026-10-22 (owner) · the steps this step waits for (services/recipe/step_dependency.py).
 *
 * "configuration me steps ko dependency denge, uske hisab se operator view me dikhayenge — dependent hai
 * to next hide rahega jaise abhi hai."
 *
 * None chosen: the step waits for every step before it — the operation's order, as it always has. Some
 * chosen: it waits for those steps only, so two steps that wait on the same step are worked side by side
 * on the tablet. Only steps BEFORE it at the same level are offered (the top of the operation, or the
 * same repeat / lane): the server refuses anything else.
 */
import React, { useMemo } from "react";
import { Select, Typography } from "antd";

const { Text } = Typography;

const byRank = (nodes) => [...(nodes || [])].sort((a, b) => (a.position ?? a.rank ?? 0) - (b.position ?? b.rank ?? 0));

/** The STEPs before `code` among its own siblings, in the order the operation runs them. */
export function dependencyCandidates(operation, code) {
  let found = null;
  const walk = (nodes) => {
    if (found) return;
    const list = byRank(nodes);
    const at = list.findIndex((n) => n.code === code);
    if (at >= 0) {
      found = list.slice(0, at).filter((n) => n.kind === "STEP" && n.code);
      return;
    }
    list.forEach((n) => walk(n.children));
  };
  walk(operation?.children);
  return found || [];
}

export default function DependsOnField({ step, operation, readOnly, onChange }) {
  const candidates = useMemo(() => dependencyCandidates(operation, step?.code), [operation, step?.code]);
  const value = (step?.after_steps || []).filter(Boolean);
  const label = (c) => `${c.code} · ${c.title || c.label || ""}`.trim();
  return (
    <div>
      <Select
        mode="multiple" size="small" style={{ width: "100%" }} allowClear disabled={readOnly || !candidates.length}
        value={value} placeholder={candidates.length ? "The previous steps (as now)" : "No step before this one at its level"}
        onChange={(v) => onChange({ after_steps: v || [] })}
        optionFilterProp="label"
        options={candidates.map((c) => ({ value: c.code, label: label(c) }))}
      />
      <Text className="u0-edit-hint" type="secondary" style={{ display: "block", marginTop: 6, fontSize: "calc(12.5px * var(--dz-fs, 1))" }}>
        {!candidates.length
          ? "This is the first step here (of the operation, or of its repeat / lane), so there is no earlier step to depend on. It opens when the operation starts."
          : value.length
          ? `On the tablet this step opens once ${value.join(", ")} ${value.length === 1 ? "is" : "are"} done — it does not wait for the other steps before it.`
          : "Nothing chosen: this step opens once every step before it is done, as now."}
      </Text>
    </div>
  );
}
